import { Component, Input } from '@angular/core';

@Component({
  selector: 'bkg-loading',
  templateUrl: './loading.component.html',
})
export class LoadingComponent {
  @Input() isLoading: number;

  get showLoading(): boolean {
    return this.isLoading > 0;
  }
}
